import { useContext, useMemo } from "react";
import {
  Navigate,
  Route,
  RouterProvider,
  Routes,
  createHashRouter,
} from "react-router-dom";
import { AuthContext } from "../context";

// Layout
import Layout from "./layout";

// Auth
import Login from "../screens/auth/login";
import Logout from "../screens/auth/logout";
import Recover from "../screens/auth/recover";
import Reset from "../screens/auth/reset";

// Admin Screens
import AdminHome from "../screens/admin/home/home";
import ViewFinish from "../screens/admin/home/view-finish";
import ViewActivity from "../screens/admin/home/view-activity";
import ViewContent from "../screens/admin/home/view-content";
import AdminClients from "../screens/admin/clients/clients";
import CreateClient from "../screens/admin/clients/create-client";
import AdminModerators from "../screens/admin/moderators/moderators";
import CreateModerator from "../screens/admin/moderators/create-moderator";
import AdminPackages from "../screens/admin/packages/packages";
import CreatePackage from "../screens/admin/packages/create-package";
import ViewPhotos from "../screens/admin/packages/view-photos";
import ViewPhotosDetails from "../screens/admin/packages/view-photos-details";
import AdminProducts from "../screens/admin/products/products";
import Profile from "../screens/admin/profile/profile";

const Router = () => {
  const { isLogged } = useContext(AuthContext);

  const authRouter = useMemo(
    () =>
      createHashRouter([
        {
          index: true,
          path: "/",
          element: <Login />,
        },
        {
          path: "/recover",
          element: <Recover />,
        },
        {
          path: "/recover/:code",
          element: <Reset />,
        },
        {
          path: "*",
          element: <Navigate to="/" replace />,
        },
      ]),
    [],
  );

  const adminRouter = useMemo(
    () =>
      createHashRouter([
        {
          path: "/logout",
          element: <Logout />,
        },
        {
          path: "*",
          Component: AdminRoutes,
        },
      ]),
    [],
  );

  return <RouterProvider router={isLogged ? adminRouter : authRouter} />;
};

const AdminRoutes = () => (
  <Routes>
    <Route element={<Layout />}>
      <Route path="/" element={<AdminHome />} />
      <Route path="/admin/clients" element={<AdminClients />} />
      <Route path="/admin/clients/create" element={<CreateClient />} />
      <Route path="/admin/moderators" element={<AdminModerators />} />
      <Route path="/admin/moderators/create" element={<CreateModerator />} />
      <Route path="/admin/packages" element={<AdminPackages />} />
      <Route path="/admin/packages/create" element={<CreatePackage />} />
      <Route path="/admin/packages/finish" element={<ViewFinish />} />
      <Route path="/admin/packages/view-activity" element={<ViewActivity />} />
      <Route path="/admin/packages/view-content" element={<ViewContent />} />
      <Route path="/admin/packages/photos" element={<ViewPhotos />} />
      <Route
        path="/admin/packages/photos/details"
        element={<ViewPhotosDetails />}
      />
      <Route path="/admin/products" element={<AdminProducts />} />
      <Route path="/admin/profile" element={<Profile />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Route>
  </Routes>
);

export default Router;
